import { render, staticRenderFns } from "./2_m_faq.vue?vue&type=template&id=76220c12&scoped=true&"
import script from "./2_m_faq.vue?vue&type=script&lang=js&"
export * from "./2_m_faq.vue?vue&type=script&lang=js&"
import style0 from "./2_m_faq.vue?vue&type=style&index=0&id=76220c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76220c12",
  null
  
)

export default component.exports